import React, { PureComponent } from "react"
import styled, { keyframes } from "styled-components"
import { FadeIn } from "animate-css-styled-components"
import { FormattedMessage } from "react-intl"
import Box from "../../lib/ui/ui-box"
import LoadingSpinner from "../loading-spinner"
import Text from "../text"

const Loader = styled(LoadingSpinner)`
  width: 68px;
  height: 68px;
  border-color: white;
  border-bottom: 6px solid rgba(250, 250, 250, 0.15);
  border-left: 6px solid rgba(250, 250, 250, 0.15);
  border-right: 6px solid rgba(250, 250, 250, 0.15);
  border-top: 6px solid rgba(250, 250, 250, 0.8);
  margin-right: 24px;
`

const AnimateBG = keyframes`
  0%{background-position:0% 50%}
  50%{background-position:100% 50%}
  100%{background-position:0% 50%}
`

const Background = styled(Box)`
  background: #5c258d;
  background: linear-gradient(
    to right,
    #00b5b8,
    #2c2b59
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  display: flex;
  width: 100vw;
  height: 100vh;

  background: linear-gradient(270deg, #2c2b59, #00b5b8);
  background-size: 400% 400%;
  animation: ${AnimateBG} 30s ease infinite;
`

export default class DramaticLoader extends PureComponent {
  render() {
    return (
      <FadeIn duration="0.3s">
        <Background align="center" justify="center">
          <Box flexDirection="row" align="center" justify="center" px={[1, 0]}>
            <Loader />
            <Text
              fontWeight="700"
              fontSize={[3, 3, 5]}
              lineHeight={[3, 3, 5]}
              w={["80%", "80%", "552px"]}
              color="white"
            >
              <FormattedMessage id="newMortgage.loaderText" />
            </Text>
          </Box>
        </Background>
      </FadeIn>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dramatic-loader/dramatic-loader.component.js